class UploadTestPlanController {
    constructor(Upload, toastr, $scope) {
        this.init = () => {
            this.uploadingTestPlan = false;
            this.onUpload = () => {
                this.scope.$parent.vm.getTestSuites();
            };
        };
        this.$onInit = () => {
            this.init();
        };
        this.uploadTestPlan = (files) => {
            if (angular.isUndefined(files) || files.length === 0) {
                return;
            }
            this.uploadingTestPlan = true;
            const fileName = files[0].name;
            this.Upload.upload({
                method: 'post',
                url: 'api/TestPlans/InsertOrUpdateTestPlan',
                data: {
                    TestPlan: true,
                    Files: files
                }
            }).then((response) => {
                this.uploadingTestPlan = false;
                this.onUpload();
                let msg = '';
                angular.forEach(response.data, m => {
                    return (msg += m + ' ');
                });
                this.toastr.info(msg, 'Test Plan Updated from ' + fileName);
            }, (response) => {
                this.uploadingTestPlan = false;
                this.onError();
                if (response.status > 0) {
                    this.toastr.error(response.statusText, 'Test Plan NOT updated from ' + fileName);
                }
            });
        };
        this.Upload = Upload;
        this.toastr = toastr;
        this.scope = $scope;
    }
}
angular.module('app').component('uploadTestPlan', {
    bindings: {
        onUpload: '&',
        onError: '&'
    },
    templateUrl: 'scripts/app/partials/ManageTestSuites/upload-test-plan.tpl.html',
    controllerAs: 'vm',
    controller: UploadTestPlanController
});
